//引入axios
import axios from 'axios'
// import { createHashHistory } from 'history'
// import QS from 'qs'
let cancel ,promiseArr = {}
const CancelToken = axios.CancelToken;

axios.interceptors.request.use(config => {
   
    if (promiseArr[config.url]) {
        promiseArr[config.url]('操作取消')
        promiseArr[config.url] = cancel
    } else {
        promiseArr[config.url] = cancel
    }
      return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(
  response => {
    console.log(response.data.statue,'response')
    if(response.data.status === 402){
      // createHashHistory().push('/login')
      window.document.cookie = ''
      return
    }
          
    return response
  },
  err => {
    console.log(err,'err')  
    
    // console.err(err.message)
      return Promise.resolve(err.response)
})

axios.defaults.baseURL = '/blockchain-certificate-web/api/v1'
//设置默认请求头
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type':'application/x-www-form-urlencoded',
    'charset':'UTF-8'
    
}

axios.defaults.withCredentials = true
// axios.defaults.timeout = 10000

export default {
  //get请求
    get (url,param) {
      return new Promise((resolve,reject) => {
        axios({
          method: 'get',
          url,
          params: param,
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res)
        })
      })
    },
  //post请求,用params不会默认转json格式，而是指定格式
    post (url,param) {
      console.log(param)
      return new Promise((resolve,reject) => {
        axios({
          method: 'post',
          url,
          params: param,
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res)
        })
      })
     }
  }


// WEBPACK FOOTER //
// ./src/api/https.js